var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSigninShape2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 699,
    height: 900,
    viewBox: "0 0 699 900",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M646.979 894C630.06 1145.71 0.978821 894 0.978821 894V0H286.979C408.979 0 695.659 69.7735 698.979 260C701.88 426.235 405.557 390.216 392.979 556C380.488 720.641 658.052 729.258 646.979 894Z",
    fill: "#F1DABF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSigninShape2);
export default __webpack_public_path__ + "static/media/Signin-shape2.cd11497b44edaf178ca41329b6a38a8c.svg";
export { ForwardRef as ReactComponent };